const iconStyle = 'default';
const inlineEditor = 'tinymce';





import constants from './lib/custom/js/constants.js';
window.constants = constants;


// import beautify from 'js-beautify';
// window.beautify = beautify;
require('./css/builder_main.css');

const languageModule = require('./language/all.js');
window.LANGUAGE = languageModule.LANGUAGE;

// jquery
const jQuery = require('./lib/jquery/jquery.min.js');
window.jQuery = jQuery;
window.$ = jQuery;


// Dynamically load Pako
const pako = require('./lib/pako.min.js');
window.pako = pako;




import('./lib/jquery.bootstrap-growl.min.js').then(module => {
  window.bootstrapGrowl = $.bootstrapGrowl;
})

// import('./lib/popper.min.js')
//   .then(module => {
//     window.Popper = module.default; // Assign Popper.js to the global window.Popper
//     return import('./lib/bootstrap/bootstrap.min.js'); // Load Bootstrap after Popper is available globally
// })

// bootstrap //Don't do this dynamically it does not load the page or load it empty on 3G
window.Popper = require('./lib/popper.min.js');

// Dynamically load Bootstrap CSS and FontAwesome
import('./lib/bootstrap/bootstrap.min.css');

require('./js/themewp.js');

import('./css/font.css');
import('./css/builder_core.css');
import('./css/themewp.css');





// add all widgets from js/widgets
// import Widget from "./js/widgets/Widget.js";
// window.Widget = Widget;


// add all elements from js/elements
import SuperElement from "./js/elements/SuperElement.js";
window.SuperElement = SuperElement;
import BlockElement from "./js/elements/BlockElement.js";
window.BlockElement = BlockElement;





// something in builder ext
import {
  rgb2hex,
  rgba2hex,
  removeModalGetLinkVideo,
  modal_display,
  htmlLoader
} from './js/builder_ext.js';
window.rgb2hex = rgb2hex;
window.rgba2hex = rgba2hex;
window.removeModalGetLinkVideo = removeModalGetLinkVideo;
window.modal_display = modal_display;
window.htmlLoader = htmlLoader;

// all thing from builder
import {
  createElementFromHTML,
  makeid,
  Editor,
  simulateClick
} from './js/builder.js';
window.createElementFromHTML = createElementFromHTML;
window.makeid = makeid;
window.Editor = Editor;
window.simulateClick = simulateClick;

// Dynamically load ClipboardJS
// import('./lib/clipboard.min.js').then(({ default: ClipboardJS }) => {
//   window.ClipboardJS = ClipboardJS;
// });

// ace JS
//import * as ace from 'ace-builds/src-noconflict/ace';
//import 'ace-builds/src-noconflict/theme-monokai';
//import 'ace-builds/src-noconflict/mode-html';
//import 'ace-builds/src-noconflict/worker-html';
//window.ace = ace;


// Builder HTML Imports
import main from './main.html';
import other from './other.html';
import home from './home.html';
import contactus from './contactus.html';
import resumeatschecker from './resumeatschecker.html';
import pricing from './pricing.html';
import styles from './styles.html';
import mainhead from './mainhead.html';
import mainfooter from './mainfooter.html';
import homefooter from './homefooter.html';
import homehead from './homehead.html';
import jobposting from './jobposting.html';
import customcriteria from './texttoresume.html';
import texttocoverletter from './texttocoverletter.html';
import readymadetemplates from './readymadetemplates.html';
import sitemap from './sitemap.html';
import sitemapall from './sitemapall.html';
import privacypolicy from './privacypolicy.html';
import terms from './terms.html';
import faqs from './faqs.html';

// Cache for localized HTML templates
Editor.prototype.localizedHtmlCache = {};

// Prebuilt base HTML templates
Editor.prototype.htmlTemplates = {
  home: styles + homehead + home + other + homefooter,
  sitemap: styles + homehead + sitemap + other + homefooter,
  sitemapall: styles + homehead + sitemapall + other + homefooter,
  contactus: styles + mainhead + contactus + other + mainfooter,
  faqs:  styles + mainhead + faqs + other + mainfooter,
  resumeatschecker: styles + mainhead + resumeatschecker + other + mainfooter,
  pricing: styles +  mainhead + pricing + other + mainfooter,
  privacypolicy: styles + mainhead + privacypolicy + other + mainfooter,
  terms: styles + mainhead + terms + other + mainfooter,
  jobposting: styles + mainhead + jobposting + other + mainfooter,
  customcriteria: styles + mainhead + customcriteria + other + mainfooter,
  texttocoverletter: styles + mainhead + texttocoverletter + other + mainfooter,
  readymadetemplates: styles + mainhead + readymadetemplates + other + mainfooter,
  default: styles + mainhead + main + other + mainfooter // Default template
};

// Prepare HTML with caching and logging
Editor.prototype.prepairHtml = function (htmlfilename, locale) {
  // Normalize empty htmlfilename to "default"
  htmlfilename = htmlfilename || "default";

  // Custom render canvas/sidebar check
  if (this.canvas && this.sidePanel) {
    console.log("[prepairHtml] Canvas and sidebar exist, skipping rendering.");
    $(main);
    return;
  }

  // Generate a unique cache key
  const cacheKey = `${htmlfilename}_${locale}`;

  // Check if cached version exists
  if (this.localizedHtmlCache[cacheKey]) {
    console.log(`[prepairHtml] Using cached HTML for '${htmlfilename}' (Locale: ${locale})`);
    $('body').html(this.localizedHtmlCache[cacheKey]);
    return;
  }

  console.log(`[prepairHtml] Generating new HTML for '${htmlfilename}' (Locale: ${locale})`);

  // Load the base template if available, otherwise build it
  let html = this.htmlTemplates[htmlfilename] || this.htmlTemplates["default"];

  if (htmlfilename === "default") {
    console.log("[prepairHtml] Using 'default' template.");

    let mainHtml = $('<span>' + main + '</span>');
    let mainheadHtml = $('<span>' + mainhead + '</span>');

    let mainheadSidebarDiv = mainheadHtml.find('#leftSidebarScrollableDiv');
    let mainSidebarDiv = mainHtml.find('#leftSidebarScrollableDiv');

    if (mainheadSidebarDiv.length && mainSidebarDiv.length) {
      mainSidebarDiv.html(mainheadSidebarDiv.html());
    } else {
      console.warn('[prepairHtml] LeftSidebarScrollableDiv not found in mainhead or main');
    }

    html = mainHtml.prop('outerHTML') + other;
  }

  const customReplacements = {
    siteName: getSiteName(),
    brandSiteName: getBrandName(),
    localeLang: getLanguage(),
  };

  html = html.replace(/\{language\.([^\}]+)\}/g, (_, key) => {
    if (customReplacements[key] !== undefined) return customReplacements[key];
    if (this.I18n[key] !== undefined) return this.I18n[key];
    return `{language.${key}}`;
  });



  // Apply translations
  // Object.entries(this.I18n).forEach(([key, value]) => {
  //     html = html.split(`{language.${key}}`).join(value);
  // });

  // Store localized version in cache
  this.localizedHtmlCache[cacheKey] = html;
  console.log(`[prepairHtml] Cached new HTML for '${htmlfilename}' (Locale: ${locale})`);

  // Inject into the DOM
  $('body').html(html);
};




Editor.prototype.build = function () {
  // set inline editor
  this.inlineEditor = inlineEditor;

  // Icon style
  this.iconStyle = iconStyle;
};

// Popup
import('./scss/popup.scss');
import('./js/popup.js').then(({ PopUp }) => {
  window.PopUp = PopUp;
});
import('./js/helpPopup.js').then(({ helpPopUp }) => {
  window.helpPopUp = helpPopUp;
});

// Dynamically load SweetAlert2
import('./lib/sweetalert/sweetalert2.min.css');
import('./lib/sweetalert/sweetalert2.min.js').then(({ default: Swal }) => {
  window.Swal = Swal;
});

// Dynamically load Splide and other libraries
import('./lib/splide.min.js').then(({ default: Splide }) => {
  window.Splide = Splide;
});
import('./lib/glightbox.min.css');
import('./lib/glightbox.min.js').then(({ default: GLightbox }) => {
  window.GLightbox = GLightbox;
});



// Autocomplete JS
import('./js/autocomplete.js').then(({ acpAutocomplete, acpAddCss, acpDictionary }) => {
  window.acpAutocomplete = acpAutocomplete;
  window.acpAddCss = acpAddCss;
  window.acpDictionary = acpDictionary;
});


// Import the functions, but don't execute them here



import seoMetaManager from './lib/custom/js/seometaload.js';
window.seoMetaManager = seoMetaManager;


import loadmainimages from './lib/custom/js/loadmainimages.js';
window.loadmainimages = loadmainimages;



import { localeEvents } from './lib/custom/js/locale.js';
window.localeEvents = localeEvents();

import { PDFConfigModule } from './lib/custom/js/pagesetup.js';
window.PDFConfigModule = PDFConfigModule;

import mainPageEvents from './lib/custom/js/mainpages.js';
window.mainPageEvents = mainPageEvents;

// import { jobSearchEvents } from './lib/custom/js/jobs.js';
// window.jobSearchEvents = jobSearchEvents();

import { resumePageEvents } from './lib/custom/js/resume.js';
window.resumePageEvents = resumePageEvents();

import { homePageEvents } from './lib/custom/js/home.js';
window.homePageEvents = homePageEvents();


import browseFileEvents from './lib/custom/js/browsefiles.js';
window.browseFileEvents = browseFileEvents;


import fileUploadEvents from './lib/custom/js/fileupload.js';
window.fileUploadEvents = fileUploadEvents;


// import slidersetup from './lib/custom/js/slidersetup.js';
// window.slidersetup = slidersetup;

if (!window.slidersetup) {
  import('./lib/custom/js/slidersetup.js')
    .then((module) => {
      window.slidersetup = module.default; // Set the instance on the global object
      // Initialize or configure the module here if needed
      console.log('Slider setup initialized In Build_Production.');
    })
    .catch((error) => {
      console.error('Error importing slidersetup:', error);
    });
} else {
  console.log('Slider setup already exists.');
}


if (!window.workerInitializationEvents) {
  import('./lib/custom/js/wokerinitialization.js')
    .then((module) => {
      window.workerInitializationEvents = module.default; // Access the default export
      window.workerInitializationEvents.initializeWorker();
      console.log('workerInitializationEvents Initiliazed');
    })
    .catch((error) => {
      console.error('Error workerInitializationEvents:', error);
    });
} else {
  console.log('window.workerInitializationEvents exists.');
}

import horizontalslidersetup from './lib/custom/js/horizontalslidersetup.js';
window.horizontalslidersetup = horizontalslidersetup;



import createUpdateFileJson from './lib/custom/js/createupdatefilejson.js';
window.createUpdateFileJson = createUpdateFileJson;

import renameAsEvents from './lib/custom/js/renameas.js';
window.renameAsEvents = renameAsEvents;

import saveAsEvents from './lib/custom/js/saveas.js';
window.saveAsEvents = saveAsEvents;


import { recaptchaVerification } from './lib/custom/js/recaptcha.js';
window.recaptchaVerification = recaptchaVerification;

import createUpdateFilesEvents from './lib/custom/js/createupdatefilejson.js';
window.createUpdateFilesEvents = createUpdateFilesEvents;

import leftsidebarpopulate from './lib/custom/js/leftsidebarpopulate.js';
window.leftsidebarpopulate = leftsidebarpopulate;

import utilsEvents from './lib/custom/js/utils.js';
window.utilsEvents = utilsEvents;

import faqsEvents from './lib/custom/js/faq.js';
window.faqsEvents = faqsEvents;

import reviewsEvents from './lib/custom/js/reviews.js';
window.reviewsEvents = reviewsEvents;

import contactFormEvents from './lib/custom/js/contactus.js';
window.contactFormEvents = contactFormEvents;

import footerModule from './lib/custom/js/footer.js';
window.footerModule = footerModule;

import staticModalModule from './lib/custom/js/loadstaticfiles.js';
window.staticModalModule = staticModalModule;

import highlightModule from './lib/custom/js/highlightStroke.js';
window.highlightModule = highlightModule;

import jobpostexamples from './lib/custom/js/jobpostexamples.js';
window.jobpostexamples = jobpostexamples;


import chatgptButtonLayoutAdjuster from './lib/custom/js/chatgptboxlayoutadjuster.js';
window.chatgptButtonLayoutAdjuster = chatgptButtonLayoutAdjuster;

import loadStaticPagesModule from './lib/custom/js/loadstaticpages.js';
window.loadStaticPagesModule = loadStaticPagesModule;

import htmlSitemapGenerator from './lib/custom/js/sitemapgenerator.js';
window.htmlSitemapGenerator = htmlSitemapGenerator;

import pricingEvents from './lib/custom/js/pricingload.js';
window.pricingEvents = pricingEvents;

import paymentDialog from './lib/custom/js/paymentdialog.js';
window.paymentDialog = paymentDialog;


import('./lib/punycode.min.js').then((module) => {
  window.punycode = module.default || module.punycode || module;
});








